<template>
  <MetricsSummaryWithLoader
    :loading="loading"
    :number-of-summary-skeletons="4"
    :summaries="summaries"
    :project-name="projectName"
    :date-range="dateRange"
  />
</template>

<script setup>
import MetricsSummaryWithLoader from '@/components/insights/Metrics/MetricsSummaryWithLoader.vue';
import { computed } from 'vue';
import { numberWithCommas } from '@/helpers/formatters';
import { useColors } from '@/composables/colors';
import { getTooltip } from '@/helpers/tooltips';

const { brandPrimary } = useColors();

const props = defineProps({
  loading: {
    type: Boolean,
    default: false,
  },
  data: {
    type: Object,
    default: () => ({}),
  },
  tooltips: {
    type: Object,
    default: () => ({}),
  },
  projectName: {
    type: String,
    default: '',
  },
  dateRange: {
    type: Object,
    default: () => ({}),
  },
});

const summaries = computed(() => {
  const { applicationsReceived, overallPassthroughRate, hiresMade } = props.data || {};
  return [
    {
      id: 'applications-received',
      label: 'Applications Received',
      value: numberWithCommas(applicationsReceived),
      color: brandPrimary.value,
      link: {
        name: 'Pass-through Report',
        to: 'pass-through',
      },
      tooltipKey: 'executive-apps-received',
    },
    {
      id: 'overall-pass-through-rate',
      label: ['Overall', 'Pass-through Rate'],
      value: overallPassthroughRate ? `${numberWithCommas(overallPassthroughRate, 1)}%` : 0,
      color: brandPrimary.value,
      link: {
        name: 'Pass-through Report',
        to: 'pass-through',
      },
      summaryLabelWidth: '150px',
      tooltipKey: 'executive-pass-thru',
    },
    {
      id: 'hires-made',
      label: 'Hires Made',
      value: numberWithCommas(hiresMade),
      color: brandPrimary.value,
      link: {
        name: 'Hiring Report',
        to: 'hiring-report',
      },
      summaryLabelWidth: '65px',
      tooltipKey: 'executive-hires',
    },
    {
      id: 'open-requisitions',
      label: 'Open Requisitions',
      comingSoon: true,
    },
  ].map((summary) => ({
    ...summary,
    tooltip: getTooltip(summary.tooltipKey),
  }));
});
</script>
